import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";

const Panel = ({ onSubmit}) => {
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
      </div>
      <button
        className={cn("button", styles.button)}
        onClick={onSubmit}
      >
        Save
      </button>
    </div>
  );
};

export default Panel;
